import { Alert, message } from "antd";
import { useEffect, useState } from "react";
import _NewapplicationService from "../../modules/NewapplicationService";
import { COMMON_ERROR_MSG } from "../../constants/constants";

const LatestComments = ()=> {
     const [allComments, setAllComments] = useState([]);
        const [loading, setLoading] = useState(false);
         const ApplicationObjId = parseInt(localStorage.getItem("ApplicationObjId"));
    const ApplicationStatusId = JSON.parse(localStorage.getItem("ApplicationStatusId"));
     useEffect(() => {
        getReviewCommentByApplicationId(ApplicationObjId);
    }, []);

const getReviewCommentByApplicationId = async (ApplicationObjId) => {
  setLoading(true);
  try {
    const res = await _NewapplicationService.getReviewCommentByApplicationId(ApplicationObjId);

    if (res.data.IsSuccess) {
      const comments = res.data.Obj || [];

      // Proceed only if the last record has ApplicationStaus === "Action Required"
      const lastRecord = comments[comments.length - 1];
      if (lastRecord && lastRecord.ApplicationStaus === "Action Required") {
        
        // Filter out records where Section === "common"
        const filtered = comments.filter(
          (item) => item.Section !== "common"
        );

        // Take the last 3 records after filtering
        const lastThree = filtered.slice(-3);

        setAllComments(lastThree);
      } else {
        // If condition not met, clear or show message
        setAllComments([]);
        message.info("No relevant comments found.");
      }
    } else {
      message.error(res.data.Message || COMMON_ERROR_MSG);
    }
  } catch (err) {
    console.log(err);
    message.error(COMMON_ERROR_MSG);
  } finally {
    setLoading(false);
  }
};
const getSectionLabel = (section) => {
  switch (section?.toLowerCase()) {
    case "incomesource":
      return "Income Sources";
    case "balancesheetasset":
      return "Balance Sheet - Assets";
    case "aapplicationidentification":
      return "Identification Details";
    case "coborrowerdetails":
      return "Co-Borrower";
    case "coborroweridentification":
      return "Co-Borrower's Identification";
    case "personalfinancialstatement":
      return "Documents";
      case "balancesheettotalasset":
      return "Balance Sheet -Total Assets";
      case "balancesheetliability":
      return "Balance Sheet - Total Liabilities";
       case "questionair":
      return "Balance Sheet - Questionnaire";
       case "proofoftrust":
      return "Proof Of Trust";
    default:
      return section; 
  }
};

console.log(allComments, "allcomments")
    return(
        <>
     {allComments.length > 1 && (
  <Alert
   className="bankerCOmmentMsgBox"
    message={
      <span>
        Action needed on bankers comments:{" "}
        <b className="blinkText">{getSectionLabel(allComments[0]?.Section)}</b> {allComments[1]?.Section ? "," : null} <b  className="blinkText">{getSectionLabel(allComments[1]?.Section)}</b> {allComments[2]?.Section ? "," : null} <b  className="blinkText">{getSectionLabel(allComments[2]?.Section)}</b> {allComments[3]?.Section ? "," : null} <b  className="blinkText">{getSectionLabel(allComments[3]?.Section)}</b>
      </span>
    }
    type="info"
    showIcon={false}
    style={{
      backgroundColor: "#fdecea",
      border: "1px solid #f5c2c7",
      color: "#b71c1c",
      borderRadius: "6px",
    }}
  />
)}


        </>
    )
}
export default LatestComments;